"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeForInStatement = void 0;
const react_peg_1 = require("react-peg");
const basic_1 = require("../basic");
const common_1 = require("../common");
const expression_1 = require("../expression");
const statement_1 = require("./statement");
function findProp(obj, name) {
    return obj.props.find(prop => prop.kind === "TypeObjectProperty" && prop.name.kind === "Identifier" && prop.name.name === name);
}
function TypeForInStatement() {
    const action = ({ key, keys, returnType }) => {
        // TODO: returnType must be object type { key: ..., value: ... }
        const pair = returnType.argument;
        // may be used in as clause
        const as = findProp(pair, "key");
        const value = findProp(pair, "value").value;
        return {
            kind: "TypeForInStatement",
            key,
            keys,
            as,
            value
        };
    };
    return (react_peg_1.ReactPeg.createChunk("pattern", { action: action },
        common_1.Text("for"),
        common_1.Text("("),
        react_peg_1.ReactPeg.createChunk(basic_1.Identifier, { label: "key" }),
        common_1.Text("in"),
        react_peg_1.ReactPeg.createChunk(expression_1.TypeExpression, { label: "keys" }),
        common_1.Text(")"),
        common_1.Text("{"),
        react_peg_1.ReactPeg.createChunk(statement_1.TypeReturnStatement, { label: "returnType" }),
        common_1.Text("}")));
}
exports.TypeForInStatement = TypeForInStatement;
